module.exports = __webpack_public_path__ + "img/logo_dark.ef21111a.png";